// extracted by mini-css-extract-plugin
module.exports = {"open-select":"customSelect_open-select__3ETKC","open-select--other-active":"customSelect_open-select--other-active__8hPuT"};